<template>
  <q-dialog v-model="treeDialog">
    <q-card
      class="resultsModal"
      style="min-width: 100%; min-height: 100%; border-radius: 10px"
    >
      <q-card-section align="center">
        <div style="float: right"><q-btn icon="close" flat round dense v-close-popup class="circle-btn text-primary" style="margin-bottom: 0px" /></div>
        <div class="text-h6" style="font-weight: bold;float: center;">{{ treeTitle }}</div>
      </q-card-section>

      <q-card-section>
        <q-input dense filled v-model="filter" label="Filter" style="width: 20%"/>
        <q-tree
          :nodes="nodes"
          v-model:expanded="expandedNodes"
          node-key="nodeKey"
          :filter="filter"
        />
      </q-card-section>

      <q-card-actions align="center">
        <q-btn
          label="Close"
          text-color="white"
          style="margin-right: 20px; background: #0067c1"
          no-caps
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from "vue";
import CommonHelper from "../helper/CommonHelper.js";

export default {
  setup() {
    const treeDialog = ref(false);
    const documentId = ref("");
    const treeTitle = ref("");

    const filter = ref('');

    const nodes = computed(() => {
      return CommonHelper.storedZipFileData.value[documentId.value];
    });

    const expandedNodes = ref([]);

    /*
     * Display the tree modal
     */
    function displayTreeModal(newDocumentId, newTreeTitle) {
      documentId.value = newDocumentId;
      treeTitle.value = newTreeTitle;
      treeDialog.value = true;
    }

    return {
      //variable properties
      treeDialog,
      treeTitle,
      nodes,
      expandedNodes,
      filter,

      //functions
      displayTreeModal
    };
  }
};
</script>